import Vue from 'vue';
import App from './App.vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { firestorePlugin } from 'vuefire';
import firebaseConfig from './config/firebase.config';
import VueCookies from 'vue-cookies';

Vue.config.productionTip = false;

Vue.use(firestorePlugin);
Vue.use(VueCookies);

// Firebase
firebase.initializeApp(firebaseConfig);

// Tracking Cookies
if (!Vue.$cookies.get('consent')) {
    Vue.$cookies.set('consent', {complied: false, ga_disabled: true});
}
window[`ga-disable-${process.env.VUE_APP_FIREBASE_MEASUREMENT_ID}`] = Vue.$cookies.get('consent').ga_disabled;

firebase.auth().onAuthStateChanged(user => {
    store.dispatch('auth/fetchUser', user).then(() => {
        new Vue({
            store,
            vuetify,
            router,
            render: h => h(App)
        }).$mount('#app');
    });
});
